import React from "react";
import CustomModal from "./CustomModal";
import ContentBox from "./ContentBox";

const ModalNotification = ({ show, setShow, close, title, ...props }) => {
	return (
		<CustomModal show={show} setShow={setShow}>
			<ContentBox title={title} close={close}>
				{props.children}
			</ContentBox>
		</CustomModal>
	);
};

export default ModalNotification;
